import { useContext, useState } from "react";

import Title from "@/components/layout/title";
import AccountSideModal from "@/components/modals/profile/account-side-modal";
import SubscriptionSideModal from "@/components/modals/profile/subscription-side-modal";
import ProfileCard from "@/components/profile/profile-card";
import DiseaseLabel from "@/components/ui/disease-label";
import { AuthContext } from "@/contexts/auth-context";
import {
  SubscriptionTier,
  getSubscriptionLabelAndPrice,
} from "@/types/api/user";

const ProfilePage = () => {
  const { user, logout } = useContext(AuthContext);

  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  if (!user) return;

  const subscriptionInfo = getSubscriptionLabelAndPrice(
    user.subscriptionTier ?? SubscriptionTier.FULL
  );

  return (
    <div className="flex flex-col w-full gap-6 px-[5%] pb-8">
      <Title title={`Paramètres`} subTitle="" className="flex flex-col gap-4" />
      {/* Settings Cards */}
      <div className="flex gap-6 flex-wrap">
        {/* Account Info */}
        <ProfileCard
          title="Information générales"
          updateLabel="Modifier mes informations"
          onUpdateClick={() => setIsAccountModalOpen(true)}
          onDeleteClick={logout}
          deleteLabel="Déconnexion"
        >
          <div className="columns-2 gap-4 px-5 pt-[10px] pb-5">
            <div>
              <div className="text-xs text-[#64748B]">{"Nom"}</div>
              <div className="text-sm break-words">{user.lastName}</div>
            </div>
            <div>
              <div className="text-xs text-[#64748B]">{"Email"}</div>
              <div className="text-sm break-words">{user.email}</div>
            </div>
            <div>
              <div className="text-xs text-[#64748B]">{"Prénom"}</div>
              <div className="text-sm break-words">{user.firstName}</div>
            </div>
            <div>
              <div className="text-xs text-[#64748B]">{"Mot de passe"}</div>
              <div className="text-sm">
                {"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"}
              </div>
            </div>
          </div>
        </ProfileCard>

        {/* Subscription Info */}
        <ProfileCard
          title="Abonnement"
          updateLabel="Modifier mon abonnement"
          onUpdateClick={() => setIsSubscriptionModalOpen(true)}
        >
          {/* Content */}
          <div className="flex h-full gap-8 px-5 pt-[10px] pb-5">
            <div className="flex flex-1 flex-col gap-1">
              <DiseaseLabel
                customLabel="Abonnement"
                className="bg-brand-50 border-subscription-200 text-brand-700 w-fit font-medium text-sm"
              />
              <div>{`Abonnement ${subscriptionInfo?.label}`}</div>
            </div>
            <div>
              <div className="flex items-center">
                <div className="font-bold text-black text-4xl">{`${subscriptionInfo?.monthlyPrice}€`}</div>
                <div className="font-bold text-black text-xl">{"/mois"}</div>
              </div>
              <div className="text-[#64748B]">{`ou ${subscriptionInfo?.yearlyPrice}€ annuel`}</div>
            </div>
          </div>
        </ProfileCard>
      </div>
      <AccountSideModal
        open={isAccountModalOpen}
        onOpenChange={setIsAccountModalOpen}
      />
      <SubscriptionSideModal
        open={isSubscriptionModalOpen}
        onOpenChange={setIsSubscriptionModalOpen}
      />
    </div>
  );
};

export default ProfilePage;
